(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function initAutoSlider(slider) {
    if (slider.dataset.autoSliderInit) return;
    slider.dataset.autoSliderInit = '1';

    var paused = false;
    slider.addEventListener('mouseenter', function () {
      paused = true;
    });
    slider.addEventListener('mouseleave', function () {
      paused = false;
    });
    slider.addEventListener('pointerdown', function () {
      paused = true;
    });

    setInterval(function () {
      if (paused || !slider.offsetParent) return;
      var atEnd = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 2;
      if (atEnd) {
        slider.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        var item = slider.querySelector('.grid__item, .slider__slide');
        var step = item ? item.getBoundingClientRect().width + 16 : 300;
        slider.scrollBy({ left: step, behavior: 'smooth' });
      }
    }, 4000);
  }

  function scan() {
    document.querySelectorAll('.slider[id^="Slider-"]').forEach(initAutoSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
